import { gql } from '@apollo/client';

import { getClient } from '..';

/**
 * This query returns the ip location.
 */
export const GET_IP_LOCATION = gql`
  query GetIPLocation($ip: String) {
    getIPLocation(ip: $ip) {
      zip
      state
      city
      lat
      long
    }
  }
`;

export interface IPLocation {
  /**
   * Location state
   */
  state?: string;

  /**
   * Location city
   */
  city?: string;

  /**
   * Location latitude
   */
  lat?: number;

  /**
   * Location longitude
   */
  long?: number;

  /**
   * Location zip code
   */
  zip?: string;
}

export interface LocationQueryInput {
  ip?: string;
}

/**
 * Get client IP and query ip location.
 */
export const getIPLocation = async (clientIP?: string): Promise<IPLocation | null | undefined> => {
  const client = getClient();

  try {
    const {
      data: { getIPLocation },
    } = await client.query<{ getIPLocation?: IPLocation }, LocationQueryInput>({
      query: GET_IP_LOCATION,
      variables: {
        ip: clientIP,
      },
    });

    return getIPLocation;
  } catch (err) {
    console.info('Get ip location error', err);

    return null;
  }
};
